import { apolloClient } from '../graphql/client'
import { useAuthStore } from '../store/auth'
import { useCheckoutStore } from '../store/checkout'
import { useSelectionStore } from '../store/selection'
import { clearEmbedAccessToken } from './embedConfig'

/**
 * Full sign-out. Clears the Core session, the client-side basket/checkout state, and every
 * access-token source `readBootstrap()` reads — so the App gate falls back to the login screen.
 *
 * The consumer's Potentials live on Core and are not deleted here (they're theirs next time), but we
 * drop the cached copy so a different consumer never sees the previous one's basket.
 */
export async function logout(): Promise<void> {
  // 1. Access-token sources: the embed `tradeInConfig.accessToken`, the magic-link `?login=` param,
  //    and the client-side login token. Clearing these makes `readBootstrap()` return no token.
  if (typeof window !== 'undefined') {
    clearEmbedAccessToken()
    const url = new URL(window.location.href)
    if (url.searchParams.has('login')) {
      url.searchParams.delete('login')
      window.history.replaceState({}, '', url)
    }
  }

  // 2. Client state: session (also nulls loginToken) + order-feed selection + checkout progress.
  useSelectionStore.getState().clear()
  useCheckoutStore.getState().reset()
  useAuthStore.getState().logout()

  // 3. Cached server data (Potentials, config, …) so nothing leaks across sessions. clearStore (not
  //    resetStore) — we don't want to refetch authenticated queries once the session is gone.
  await apolloClient.clearStore()
}
